t = require('views/internal/teacup-with-helpers')('mini_profile')

module.exports = t.renderable ({ avatarHash, fullName, username, initials, bio, email, showEmail, isMe }) ->
  t.div '.mini-profile', ->

    t.div '.mini-profile-member.member-large', ->
      if isMe
        t.a '.av-btn.change.js-change-av', { href: '#' }, ->
          t.format 'change'
      else
        if avatarHash
          t.a '.av-btn.js-view-large', { href: '#' }
      title = "#{ fullName } (#{ username })"
      if avatarHash
        t.img '.member-avatar', { height: '50', width: '50', src: [window.avatarDomain, avatarHash, '50.png'].join('/'), alt: title, title }
      else
        t.span '.member-initials', { title }, ->
          t.text initials

    t.div '.mini-profile-info', ->
      t.h3 '.mini-profile-info-title', ->
        t.a '.mini-profile-info-title-link.js-profile', { href: '/' + username }, ->
          t.text fullName
      t.p '.quiet.u-bottom', ->
        t.format 'at-username', { username }
      if bio
        t.p '.mini-profile-info-bio.quiet', ->
          t.text bio
      if showEmail
        t.p '.u-bottom.quiet', ->
          t.text email
      if isMe
        t.p '.u-bottom', ->
          t.a '.quiet.js-edit-profile', { href: '#' }, ->
            t.format 'edit-profile-info'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/mini_profile.coffee